/**
 * Registers flat file import job types with the background jobs registry.
 * This enables the Jobs page to display import-specific results using AsyncImportResultsViewer.
 *
 * Import this file early in your app bootstrap (e.g., in App.tsx or index.tsx).
 */
import React from "react";

import { registerJobTypeRenderer } from "src/contexts/backgroundJobs/jobTypeRegistry";
import { type BackgroundJob } from "src/contexts/BackgroundJobsContext";

const LazyAsyncImportResultsViewer = React.lazy(
  () => import("./AsyncImportResultsViewer")
);

// Wrapper to adapt AsyncImportResultsViewer to the ResultsViewer interface
const ImportResultsViewer: React.FC<{
  jobId: string;
  job: BackgroundJob;
  onClose: () => void;
}> = ({ jobId, onClose }) => {
  return <LazyAsyncImportResultsViewer jobId={jobId} onClose={onClose} />;
};

// Register all import job types
registerJobTypeRenderer("ENTITY_IMPORT", {
  typeLabel: "Entity Import",
  ResultsViewer: ImportResultsViewer,
});

registerJobTypeRenderer("FIELD_IMPORT", {
  typeLabel: "Field Import",
  ResultsViewer: ImportResultsViewer,
});

registerJobTypeRenderer("CASHFLOW_IMPORT", {
  typeLabel: "Cashflow Import",
  ResultsViewer: ImportResultsViewer,
});

registerJobTypeRenderer("FIELD_VALUE_IMPORT", {
  typeLabel: "Field Value Import",
  ResultsViewer: ImportResultsViewer,
});

export {};
